<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nu0esE/tc-custom/9781526746368.jpg?1728851738752" alt="This image is the cover for the book Air War at Sea in the Second World War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Air War at Sea in the Second World War
      </h1>
      <p class="bookDescription body article font2">
        <p>Martin Bowman’s considerable experience as a military historian has spanned over forty years, during which time he has spent hundreds of hours interviewing and corresponding with numerous men and women and their relatives, in Britain, America and beyond, resulting in a wealth of material on the war at sea from World War One to the Falklands and the wars on terror.  All these narratives have been woven into a highly readable and emotional outpouring of life and death in action in all his titles, as here, in World War Two, where the men of the Fleet Air Arm and the US Navy fighter (operating bomber and torpedo carrying aircraft) describe the compelling, gripping and thought-provoking narrative of the air war in the freezing Atlantic wastes to the waters of the mighty Pacific.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin W. Bowman
      </h2>
      
      <p class="authorDescription body article">Martin Bowman is one of Britain's leading aviation authors and has written a great deal of books focussing on aspects of Second World War aviation history. He lives in Norwich in Norfolk. He is the author of many Pen and Sword Aviation titles, including all releases in the exhaustive Air War D-Day and Air War Market Garden series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Aviation
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ccbf1fbc